import { FC } from "react";
import FlightDetails from "../components/FlightDetails";
import PassengerData from "../components/PassengerData";
import PaymentDetails from "../components/PaymentDetails";
import { TravelTransactionDetailsLayoutProps } from "./types";
import BookingSummary from "../components/BookingSummary";
import { flightOrderDataMap, getBookingSummaryCardData } from "../constants";

const TravelTransactionDetailsWeb: FC<TravelTransactionDetailsLayoutProps> = ({ data }) => {
  return (
    <div className="flex w-full gap-2 md:gap-10 ">
      <div className="flex-3">
          <div className="flex flex-col gap-4">
            <BookingSummary cardData={getBookingSummaryCardData(data)} dataMap={flightOrderDataMap} />
            <FlightDetails segments={(data?.segments ?? []) as any} />
            <PassengerData passengers={data?.passengers ?? []} />
          </div>
      </div>
      <div className="flex-1">
          <div className="flex flex-col">
            <PaymentDetails data={data} />
          </div>
      </div>
    </div>
  );
};

export default TravelTransactionDetailsWeb;
